import { Spacer } from '@chakra-ui/react';
import PieChartCompanyList from 'presentation/components/shared/chart/pieChart/PieChartCompanyList';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import { companiesPieColorsSelector } from 'selectors/modules/companies/companiesPieColors';
import useUpdateCompaniesPieColors from 'hooks/modules/companiesPieColors/useUpdateCompaniesPieColors';
import PortfolioCompositionPieChart from './PortfolioCompositionPieChart';
import { StrategyPortfolioItem } from 'model/modules/strategies/strategies';

interface Props {
  companies: StrategyPortfolioItem[];
}

const PortfolioCompositionCard: FC<Props> = ({ companies }) => {
  const { t } = useTranslation();

  const pieColors = useAppSelector(companiesPieColorsSelector);

  useUpdateCompaniesPieColors(companies.map((company) => company.name));

  return (
    <>
      <GridHeading>{t('strategyPortfolioComposition')}</GridHeading>
      <AppCard p="20px" display="flex">
        <PortfolioCompositionPieChart companies={companies} pieColors={pieColors} />
        <Spacer maxW="40px" w="40px" />
        <PieChartCompanyList items={companies} pieColors={pieColors} />
      </AppCard>
    </>
  );
};

export default PortfolioCompositionCard;
